module.exports = __webpack_public_path__ + "img/content5_130_15.a2250d8c.png";